/**
 * Button
 */

import * as React from 'react';
import * as S from './styles';

// export interface ButtonProps {
//   /** router specific Link component */
//   component?: React.ComponentType<{
//    ,to?: string;
//   }>;
//   /** click handler */
//   onClick?: (e: React.MouseEvent) => void;
//   /** true for secondary styles */
//   secondary?: boolean;
//   /** href or route the Button should go to */
//   url?: string;
// }

/** Everlywell Button */
// const Button: React.FC<ButtonProps> = ({
const Button = ({
  component,
  onClick,
  children,
  secondary,
  url,
  ...extraProps
}) => {
  // const handleClick = ( event: React.MouseEvent) => {
  const handleClick = event => {
    if (onClick) {
      onClick(event);
    }
  };

  if (component) {
    const ComponentProp = component;

    return (
      <S.ComponentWrapper secondary={secondary} onClick={handleClick}>
        <ComponentProp to={url} {...extraProps}>
          {children}
        </ComponentProp>
      </S.ComponentWrapper>
    );
  }

  if (url) {
    return (
      <S.A
        href={url}
        onClick={handleClick}
        secondary={secondary}
        {...extraProps}
      >
        {children}
      </S.A>
    );
  }

  return (
    <S.Button onClick={handleClick} secondary={secondary} {...extraProps}>
      {children}
    </S.Button>
  );
};

export { Button };

export default Button;
